import { render, staticRenderFns } from "./WhatIsIt.vue?vue&type=template&id=5649fe10&"
import script from "./WhatIsIt.vue?vue&type=script&lang=js&"
export * from "./WhatIsIt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports